import { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../Images/opportunityImg.jpg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import axios from "axios";
import emailjs from "@emailjs/browser";

export const OpportunityForm = (props) => {
  const [status, setStatus] = useState({});

  const [resumeLink, setResumeLink] = useState("");
  const [isOthersSelected, setIsOthersSelected] = useState(false);

  async function tempSub(img) {
    const data = new FormData();
    data.append("file", img);
    data.append("upload_preset", "unicorn-bridge");
    data.append("cloud_name", "dnuc0ukxf");
    data.append("api_key", "618922484172698");
    await fetch("https://api.cloudinary.com/v1_1/:dnuc0ukxf/image/upload", {
      method: "post",
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        setResumeLink(data.url);
        alert("Resume uploaded successfully, you can go ahead now!");
      })
      .catch((error) => {
        alert(error);
      });
  }

  const [attachment, setAttachment] = useState("");

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    if (resumeLink === "") {
      alert("Oops, plz upload resume and hit upload before submitting.");
      return;
    }

    emailjs
      .sendForm("service_4sma3tu", "template_54xgjd9", form.current, {
        publicKey: "NX8dtxSm_4zpWt7aV",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <section
      className="opportunity-form"
      id="query"
      style={{
        ...(props.withoutBackground && { backgroundColor: "transparent" }),
      }}
    >
      <h2
        style={{
          marginBottom: "0",
        }}
      >
        Join Our Team
      </h2>
      <p
        style={{
          marginBottom: "10px",
        }}
      >
        Join our amazing team according to your preference and experience.
      </p>
      <Container>
        <Row className="align-items-center">
          {!props.isMobileDevice && (
            <Col
              style={{
                marginTop: "-6rem",
              }}
              size={12}
              md={6}
            >
              <TrackVisibility>
                {({ isVisible }) => (
                  <img
                    className={
                      isVisible ? "animate__animated animate__zoomIn" : ""
                    }
                    src={contactImg}
                    alt="Contact Us"
                    style={{
                      height: "55vh",
                    }}
                  />
                )}
              </TrackVisibility>
            </Col>
          )}
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  {/* <h2>
                    {props.selectedOpportunity === "ca-aspirant"
                      ? "CA Aspirant"
                      : props.selectedOpportunity === "professional"
                      ? "Professional"
                      : "Job Seeker"}
                  </h2> */}

                  <form ref={form} onSubmit={sendEmail}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input type="text" placeholder="Name" name="name" />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          placeholder="Father's Name"
                          name="fatherName"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          placeholder="Contact No."
                          name="contactNo"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="email" placeholder="Email" name="email" />
                      </Col>

                      <Col size={12} sm={6} className="px-1">
                        <select
                          id="jobRole"
                          name="jobRole"
                          placeholder="Job Role"
                          onChange={(event) => {
                            setIsOthersSelected(event.target.value === "Other");
                          }}
                        >
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            Job Role
                          </option>
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            Professional
                          </option>
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            CA Aspirant
                          </option>
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            Accounts Executive
                          </option>
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            Audit Assistant
                          </option>
                          <option
                            style={{
                              color: "black",
                            }}
                          >
                            Other
                          </option>
                        </select>
                      </Col>

                      {isOthersSelected && (
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="text"
                            placeholder="Specify Job Role"
                            name="othersJobROle"
                          />
                        </Col>
                      )}

                      <Col
                        style={{
                          display: "flex",
                          alignItems: "center",
                          // justifyContent: "space-between",
                          gap: "1rem",
                        }}
                        size={12}
                        sm={12}
                        className="px-1"
                      >
                        <Col size={12} sm={6}>
                          <div style={{ position: "relative" }}>
                            <label
                              htmlFor="file-upload"
                              style={{
                                display: "inline-block",
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                color: "white",
                                borderRadius: "1rem",
                                cursor: "pointer",
                                textAlign: "center",
                                width: "100%",
                                height: "100%",
                                border: "1px solid rgba(255, 255, 255, 0.5)",
                                fontSize: "18px",
                              }}
                            >
                              Upload Resume
                            </label>
                            <input
                              id="file-upload"
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                setAttachment(e.target.files[0]);
                              }}
                              style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </Col>
                        <button
                          style={{
                            marginTop: "-7px",
                            borderRadius: "1rem",
                          }}
                          onClick={() => {
                            alert(
                              "We are uploading your resume, plz wait for conformation before submitting the form."
                            );
                            tempSub(attachment);
                          }}
                          type="button"
                        >
                          <span>Upload</span>
                        </button>
                      </Col>

                      <Col
                        style={{
                          display: "none",
                        }}
                        size={12}
                        sm={16}
                        className="px-1"
                      >
                        <input name="attachment" value={resumeLink}></input>
                      </Col>

                      <Col size={12} sm={16} className="px-1">
                        <textarea
                          rows="6"
                          placeholder="About You"
                          name="aboutYou"
                        ></textarea>
                      </Col>

                      <Col
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        size={12}
                        sm={16}
                        className="px-1"
                      >
                        <button type="submit">
                          <span>Submit</span>
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
